/**
 * Called when <service>.<operation>(...) is invoked.
 */ const operationInvokeFn = (_, schema, args)=>{
    const queryOperationMethods = [
        'get',
        'head',
        'options'
    ]; // todo::make it shared
    const isQueryOperationType = queryOperationMethods.includes(schema.method);
    const [options, client] = args;
    const invokeSchema = isQueryOperationType && 'queryKey' in options ? options.queryKey[0] : schema;
    const invokeParameters = isQueryOperationType && 'queryKey' in options ? options.queryKey[1] : 'parameters' in options ? options.parameters : undefined;
    return client(invokeSchema, {
        ...options,
        parameters: invokeParameters
    });
};

export { operationInvokeFn };
//# sourceMappingURL=operationInvokeFn.js.map
